import { useSearchParams } from 'react-router';

import { ESCROW_INVITATION_SEARCH_PARAM } from 'src/shared/constants';

export const useInvitationSearchParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const closeInvitation = () =>
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(ESCROW_INVITATION_SEARCH_PARAM);
        return next;
      },
      { replace: true },
    );

  return { invitationId: searchParams.get(ESCROW_INVITATION_SEARCH_PARAM), closeInvitation };
};
